import HeartWaveMark from "@/components/ui/HeartWaveMark";

/**
 * Editorial pull-quote band — a moment of pause between sections.
 * Minimalist, elegant, brand-aligned.
 */
export default function Manifest() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-dusty-rose/20 blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <HeartWaveMark className="w-9 h-9 mx-auto text-accent-magenta/80" strokeWidth={1.4} />
        <p className="mt-7 font-serif italic text-[1.65rem] md:text-[2.1rem] lg:text-[2.4rem] text-editorial-dark leading-[1.25]">
          La terapia no busca arreglar lo que somos.
          <br className="hidden md:block" />
          <span className="text-terracotta"> Busca acompañarnos</span> a habitarlo con más
          ternura.
        </p>

        <div className="mt-9 flex items-center justify-center gap-3 text-[0.72rem] tracking-[0.32em] uppercase text-editorial-gray">
          <span className="block h-px w-10 bg-editorial-gray/40" />
          Manifiesto
          <span className="block h-px w-10 bg-editorial-gray/40" />
        </div>
      </div>
    </section>
  );
}
